import {
  CampaignEntryPauseReason,
  IAutomationScopeData,
  IBrand,
  IMarketingCampaign,
  IMarketingCampaignEntry,
  IMarketingCampaignRun,
  IMarketingCampaignStepConversion,
  IPatient,
  MarketingCampaignEntryStatus,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseMock,
  MockTimestamp,
  Properties,
  uid,
} from '@principle-theorem/shared';
import { MockDocRef, MockNamedDocument } from '@principle-theorem/testing';

export class CampaignEntryMock
  extends BaseMock<Properties<IMarketingCampaignEntry>>
  implements Properties<IMarketingCampaignEntry>
{
  brandRef = MockDocRef<IBrand>();
  campaignRef = MockDocRef<IMarketingCampaign>();
  campaignRunRef = MockDocRef<IMarketingCampaignRun>();
  enrolledByCampaignRunRef = MockDocRef<IMarketingCampaignRun>();
  patient = MockNamedDocument<IPatient>();
  status = MarketingCampaignEntryStatus.Active;
  scopeLabel = 'Test Scope';
  scopeData: IAutomationScopeData = {
    scope: TemplateScope.None,
  };
  steps = [];
  currentStep = MockDocRef<IMarketingCampaignStepConversion>();
  deleted = false;
  hasDuplicateEmail = false;
  hasDuplicateMobile = false;
  normalisedEmail = '';
  normalisedMobile = '';
  conversionUid = uid();
  errorMessage = 'No Error';
  pauseReason = CampaignEntryPauseReason.UserInitiated;
  pausedAt = MockTimestamp();
  resumedAt = MockTimestamp();
  startedAt = MockTimestamp();
  estimatedTotalCost = 0;
  incurredCost = 0;
  billingAlertAcknowledged = false;
}
